import { marquee } from "@/content/copy";

const Row = ({ hidden }) => (
  <div className="ph-marquee-row" aria-hidden={hidden || undefined}>
    {marquee.map((q) => (
      <span key={q} className="ph-marquee-item">
        {q}
        <svg viewBox="0 0 24 24" className="ph-marquee-star" aria-hidden="true"><path d="M12 2 C12 9 15 12 22 12 C15 12 12 15 12 22 C12 15 9 12 2 12 C9 12 12 9 12 2Z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="A preview of prompts we hope to share" className="ph-marquee">
    <div className="ph-marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
